<script setup lang="ts">
import AutoComplete from '~/components/Aggregates/Search/AutoComplete.vue';
import { AisInstantSearch } from 'vue-instantsearch/vue3/es';

import AlgoliaSearchIcon from '~/components/Aggregates/Navigation/AlgoliaSearchIcon.vue';
import Navigation from '~/components/Aggregates/Navigation/Navigation.vue';
import { type Navigation as NavigationType } from './types';
import HeaderBasketControls from '~/components/Aggregates/Navigation/HeaderBasketControls.vue';
import HeaderDropdowns from '~/components/Aggregates/Navigation//HeaderDropdowns.vue';
import ArenaLogo from '~/assets/images/logos/arena.vue';
import EclipseLogo from '~/assets/images/logos/eclipse.vue';
import Logo from '~/assets/images/logos/Logo.vue';
import { useEventBus } from '@vueuse/core';
import { useAuth } from '~/composables/useAuth';

const {
  public: { algoliaIndex }
} = useRuntimeConfig();

const { userData } = useAuth();
const { isAuthenticated } = useAuth();

defineProps<{
  primaryNavigation?: NavigationType[];
}>();

const client = useAlgoliaSearchClient();
const { showArenaLogo, showEclipseLogo } = useLogo();

const isLoading = ref(true);

const logoConfigs = [
  {
    name: 'arena',
    show: showArenaLogo.value,
    component: ArenaLogo,
    colorClass: 'text-gunmetal'
  },
  {
    name: 'eclipse',
    show: showEclipseLogo.value,
    component: EclipseLogo,
    colorClass: 'text-cinnabar'
  }
];

const samplesCount = ref(0);
const basketCount = ref(0);

const getBasketCount = async () => {
  const userId = userData.value?.id;
  const { data, error } = await useFetch(`/api/commerce/basket-count?userId=${userId}`, {
    key: 'basket-count'
  });

  if (data.value) {
    samplesCount.value = data.value.samples;
    basketCount.value = data.value.main;
  }
  if (error.value) {
    console.error('Fetching basket count failed with error: ' + error.value.message);
  }
};

onMounted(() => {
  isLoading.value = false;
  // getBasketCount();
});

// onBeforeRouteUpdate((to, from, next) => {
//   // getBasketCount();
//   // next();
// });

const bus = useEventBus<string>('basket');
// bus.on(async () =>  await getBasketCount())
</script>

<template>
  <header class="flex flex-col overflow-hidden bg-white text-stormcloud print:hidden" role="banner">
    <div class="container flex flex-row items-center justify-between gap-10 py-6">
      <nuxt-link href="/" class="text-stormcloud transition hover:opacity-70" aria-label="Return to homepage">
        <Logo class="h-11 w-40" role="img" aria-label="Site logo" />
      </nuxt-link>
      <div v-if="isAuthenticated" class="flex-1" role="search" aria-label="Site search">
        <template v-if="isLoading">
          <Skeleton class="ml-auto hidden h-11 w-11 rounded-full bg-gainsboro md:ml-0 md:flex md:w-full" />
          <div class="flex h-11 items-center px-[15px] md:hidden">
            <AlgoliaSearchIcon class="ml-auto" aria-hidden="true" />
          </div>
        </template>
        <AisInstantSearch v-else :index-name="algoliaIndex" :search-client="client">
          <div class="searchbox">
            <AutoComplete />
          </div>
        </AisInstantSearch>
      </div>
      <div
        v-show="logoConfigs.some(config => config.show)"
        class="hidden h-fit w-fit flex-row items-center justify-end gap-3 text-xl lg:flex"
        role="navigation"
        aria-label="Related websites"
      >
        <Logos :logo-configs="logoConfigs" />
      </div>
      <HeaderDropdowns v-if="isAuthenticated" />
    </div>
    <div  v-if="isAuthenticated" class="container z-30 flex flex-row justify-between">
      <Navigation :primary-navigation="primaryNavigation" />
      <HeaderBasketControls :samples="samplesCount" :basket="basketCount" role="complementary" aria-label="Basket" />
    </div>
  </header>
</template>
